import { GetAllMacrouseDTO, GetAllMacrouseFiltersDTO, GetAllParcelsDTO, GetAllParcelsFiltersDTO, GetAllSpeciesDTO, GetAllSpeciesFiltersDTO, GetAllVarietyDTO, GetAllVarietyFiltersDTO, MacrouseDTO, MacrouseReviewDTO, ParcelBulkUpdateDTO, ParcelDTO, SpeciesDTO, VarietyDTO } from "./dto";
import { MacrouseServiceImpl, ParcelServiceImpl, SpeciesServiceImpl, VarietyServiceImpl } from "./serviceImpl";

export interface MacrouseService {
    CreateMacrouse(data: MacrouseDTO): Promise<void>
    UpdateMacrouse(data: MacrouseDTO, id: string): Promise<void>
    DeleteMacrouse(id: string): Promise<void>
    GetAllMacrouse(filters: GetAllMacrouseFiltersDTO): Promise<GetAllMacrouseDTO>
    GetMacrouseById(id: string): Promise<MacrouseDTO>
}

export interface SpeciesService {
    CreateSpecies(data: SpeciesDTO): Promise<void>
    UpdateSpecies(data: SpeciesDTO, id: string): Promise<void>
    DeleteSpecies(id: string): Promise<void>
    GetAllSpecies(filters: GetAllSpeciesFiltersDTO): Promise<GetAllSpeciesDTO>
    GetSpeciesById(id: string): Promise<SpeciesDTO>
}

export interface VarietyService {
    CreateVariety(data: VarietyDTO): Promise<void>
    UpdateVariety(data: VarietyDTO, id: string): Promise<void>
    DeleteVariety(id: string): Promise<void>
    GetAllVariety(filters: GetAllVarietyFiltersDTO): Promise<GetAllVarietyDTO>
    GetVarietyById(id: string): Promise<VarietyDTO>
}

export interface ParcelService {
    CreateParcel(data: ParcelDTO): Promise<void>
    UpdateParcel(data: ParcelDTO, id: string): Promise<void>
    BulkUpdateParcel(data: ParcelBulkUpdateDTO): Promise<void>
    CopyParcelFromNotification(prevNotId: string, currNotId: string): Promise<void>
    UpdateParcelsFromCsv(data: FormData): Promise<void>
    DeleteParcel(id: string): Promise<void>
    GetAllParcel(filters: GetAllParcelsFiltersDTO): Promise<GetAllParcelsDTO>
    GetParcelById(id: string): Promise<ParcelDTO>
    GetMacrouseNot(id: string): Promise<MacrouseReviewDTO>
    // FILE EXPORT
    ExportCurrentAndPreviousNotifications(currNotId: string, prevNotId?: string): Promise<void>
    ExportCompleteNotification(notId: string): Promise<void>
    IdentificationBoardNotification(notId: string): Promise<void>
}

export function NewMacrouseService(): MacrouseService {
    return new MacrouseServiceImpl()
}

export function NewSpeciesService(): SpeciesService {
    return new SpeciesServiceImpl()
}

export function NewVarietyService(): VarietyService {
    return new VarietyServiceImpl()
}

export function NewParcelService(): ParcelService {
    return new ParcelServiceImpl()
}